import { cEl } from '../../../../util';
import ManagementMenus from './ManagementMenus';

function Management() {
    const managementContainer = cEl('div');
    managementContainer.classList.add('management-container');

    const titleContainer = cEl('div');
    titleContainer.classList.add('title-container');

    const titleEl = cEl('div');
    titleEl.classList.add('title');
    titleEl.innerHTML = '관리자 설정';

    const subTitleEl = cEl('div');
    subTitleEl.classList.add('sub-title');
    subTitleEl.innerHTML = 'Admin Setting';

    titleContainer.append(subTitleEl, titleEl);

    managementContainer.append(titleContainer, ManagementMenus());

    return managementContainer;
}

export default Management;
